import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class Height extends PrimitiveValueObject<number> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: number): Height {
    if (value < 0) {
      throw new Error('正数である必要があります');
    }
    return new Height(value);
  }

  /** ラベル */
  static get label(): string {
    return '身長(cm)';
  }

  /** プレースホルダー */
  static get placeholder(): string {
    return '100';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {};
  }

  /** キー */
  static get key() {
    return 'height';
  }

  /** タイプ */
  static get type() {
    return 'number';
  }
}
